var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audio",style:(`width: ${_vm.width}`),attrs:{"preload":_vm.preload,"controls":_vm.controls,"src":_vm.src,"controlsList":"nodownload","disablePictureInPicture":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }